import { sendPasswordResetEmail } from "firebase/auth";
import { Form, Button, Spinner } from "react-bootstrap";
import messageBox from "../../assets/components/message/MessageBox";
import { app, auth } from "../../config/firebaseConfig";
import { email, loadingText, password } from "../../constants/defaultText";
import { Change, SignInFormTypes } from "../../types/authTypes";

const SignInForm = ({
  signIn,
  credentials,
  setCredentials,
  loading,
}: SignInFormTypes) => {
  const resetPassword = async () => {
    if (credentials.email === "") {
      return messageBox({
        message: "Email is verplicht",
        type: "error",
      });
    }

    try {
      await sendPasswordResetEmail(auth, credentials.email);
      messageBox({
        message: "Wachtwoord reset link is verzonden",
        type: "success",
      });
    } catch (e) {
      console.log(e);
      messageBox({
        message: "Fout tijdens het resetten van wachtwoord",
        type: "error",
      });
    }
  };

  return (
    <>
      <Form
        onSubmit={signIn}
        className="d-flex flex-column justify-content-center p-3 mb-3 text-white"
      >
        <Form.Group controlId="formBasicEmail" className="auth-input mb-3">
          <Form.Label>{email}</Form.Label>
          <Form.Control
            type="email"
            required
            value={credentials.email}
            onChange={(e: Change) =>
              setCredentials({
                ...credentials,
                email: e.target.value,
              })
            }
          />
        </Form.Group>
        <Form.Group controlId="formBasicPassword" className="auth-input mb-3">
          <Form.Label>{password}</Form.Label>
          <Form.Control
            type="password"
            required
            value={credentials.password}
            autoComplete="current-password"
            onChange={(e: Change) =>
              setCredentials({
                ...credentials,
                password: e.target.value,
              })
            }
          />
        </Form.Group>
        <div className="d-flex justify-content-between">
          <Button
            variant="outline-secondary"
            onClick={resetPassword}
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                <span className="visually-hidden">{loadingText}</span>
              </>
            ) : (
              "Reset wachtwoord"
            )}
          </Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                <span className="visually-hidden">{loadingText}</span>
              </>
            ) : (
              "Login"
            )}
          </Button>
        </div>
      </Form>
    </>
  );
};

export default SignInForm;
